import { ChatOpenAI } from '@langchain/openai';

export const llm = new ChatOpenAI({
  model: 'gpt-4o-mini',
  temperature: 2,
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
});
